import { observer } from 'mobx-react-lite'
import { Icon, Tooltip } from 'shared/ui'
import { LIVE_DOCUMENT_ACCESS_LOST_TOOLTIP } from 'entities/KnowledgeBase'

type LiveDocumentAccessLostIndicatorProps = {
  tooltipLabel?: string
  isError?: boolean
}

export const LiveDocumentAccessLostIndicator = observer(
  ({
    tooltipLabel = LIVE_DOCUMENT_ACCESS_LOST_TOOLTIP,
    isError = false,
  }: LiveDocumentAccessLostIndicatorProps) => (
    <Tooltip label={tooltipLabel} placement={'top'} width={190} breakWord>
      <Icon
        icon={'alertCircle'}
        fontSize={16}
        color={isError ? 'var(--content-negative-primary)' : 'var(--yellow-60)'}
      />
    </Tooltip>
  )
)
